function CopyrightYearReplacer() {
    document.addEventListener('DOMContentLoaded', function () {
        // Automatically Adjust the Copyright Year
        const copyrights = document.querySelectorAll(".copyright-year");
        const year = new Date().getFullYear();
        copyrights.forEach(copyright => {
            copyright.innerHTML = year;
        });
    });
}
export default CopyrightYearReplacer();